<div>
    {{data}}
</div>
